module.exports = __webpack_public_path__ + "img/sku3.beac3396.png";